module.exports = __webpack_public_path__ + "static/media/omega.1ab94aad.png";